export type ConfidenceTone = 'success' | 'warning' | 'danger' | 'ghost';

export const normalizeConfidencePercent = (confidence?: number | null): number | null => {
  if (typeof confidence !== 'number' || Number.isNaN(confidence)) {
    return null;
  }
  const normalized = confidence >= 0 && confidence <= 1 ? confidence * 100 : confidence;
  return Math.min(100, Math.max(0, normalized));
};

export const formatConfidencePercent = (confidence?: number | null): string => {
  const normalized = normalizeConfidencePercent(confidence);
  if (normalized == null) {
    return '—';
  }
  return `${Math.round(normalized)}%`;
};

export const getConfidenceTone = (confidence?: number | null): ConfidenceTone => {
  const normalized = normalizeConfidencePercent(confidence);
  if (normalized == null) {
    return 'ghost';
  }
  if (normalized >= 90) {
    return 'success';
  }
  if (normalized >= 75) {
    return 'warning';
  }
  if (normalized >= 50) {
    return 'danger';
  }
  return 'ghost';
};

export const getConfidenceBadgeClass = (confidence?: number | null): string => `ui-badge ui-badge--${getConfidenceTone(confidence)}`;

export const formatConfidenceBadgeLabel = (confidence?: number | null, suffix = 'confidence'): string => {
  const formatted = formatConfidencePercent(confidence);
  if (formatted === '—') {
    return suffix === 'confidence' ? formatted : `— ${suffix}`;
  }
  return `${formatted} ${suffix}`;
};
